export default function dexieQuery(ngDexie, $timeout, queryFactory) {
    "ngInject";

    function executeQuery(tableName, query, successCallback) {
        ngDexie.getDb(function (db) {
            var ctx = db[tableName];

            queryFactory.prepare(query);

            var filter = query.filter;

            //TODO Limit, Offset, Sorting..
            ctx.filter(filter).toArray().then(function (data) {
                $timeout(function () {
                    successCallback({'count': data.length, 'results': data});
                });
            });
        });
    }

    return {
        runQuery: executeQuery
    }
}